import { stackLayers } from './layer-stack'
import type { BoCatalog, BoOption, LayerUrls } from './types'

/** Reserved slug for artwork that is only in the browser. Never sent to the API. */
export const TRY_ON_SLUG = '__try-on__'

/**
 * The catalogue with the picked files as one extra option, so `composeAvatar` renders a candidate
 * exactly as it renders a registered one — no second rendering path to drift.
 */
export function withTryOnOption(
  catalogue: BoCatalog,
  sectionId: string,
  layers: LayerUrls,
  displayName: string,
): BoCatalog {
  const candidate: BoOption = {
    id: TRY_ON_SLUG,
    category: sectionId,
    slug: TRY_ON_SLUG,
    displayName,
    // Last in sort order so it never displaces a real option's tier position.
    sortOrder: Number.MAX_SAFE_INTEGER,
    status: 'active',
    visibility: {},
    createdAt: '',
    layers,
  }

  return { ...catalogue, options: [...catalogue.options, candidate] }
}

/** The layer to measure placement against: the base artwork, else whatever paints first. */
export function baseLayerUrl(layers: LayerUrls): string | undefined {
  const stack = stackLayers(layers)

  return (stack.find((l) => l.role === 'skin') ?? stack[0])?.url
}

export function referenceLayerUrl(
  catalogue: BoCatalog,
  sectionId: string,
): string | undefined {
  const existing = catalogue.options.filter(
    (o) =>
      o.category === sectionId && o.slug !== TRY_ON_SLUG && o.status === 'active',
  )

  for (const option of existing) {
    const url = baseLayerUrl(option.layers)
    if (url) {
      return url
    }
  }

  return undefined
}
